
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

import BitcoinDonationAddress from './BitcoinDonationAddress'

const styles = theme => ({
  footer: {
    backgroundColor: '#eeeeee',
    padding: '2.5rem 0',
    textAlign: 'left',

    '& h2': {
      marginBottom: '.85em'
    },

    '& p + h2': {
      marginTop: '2.5rem'
    }
  },
  donations: {
    borderTop: '1px solid #aaa',
    marginTop: '2.5rem',
    paddingTop: '2.5rem',

    '& span:first-child': {
      marginRight: '1rem'
    }
  }
})

class Footer extends Component {
  render() {
    const { classes } = this.props

    return (
      <footer className={classes.footer}>
        <div className="container">
          <Typography variant="title">
            What is a Bitcoin fee
          </Typography>
          <Typography>
            The way Bitcoin works is that when you make a transaction (send BTC from one address to another) you have to pay a fee. This fee is automatically deducted from the amount that you are sending, so if you are sending 0.1 BTC, the receiver will get 0.1 BTC minus the fee. The fee goes to the so called "miners" which are veryfing and processing the transactions.
          </Typography>

          <Typography variant="title">
            Why do I need this info
          </Typography>
          <Typography>
            For every 10 minutes, only a limited amount of transactions can be confirmed and those are usually the transactions with the highest fees. Some Bitcoin wallets allow you to set a custom transaction fee, so the higher fee that you set, the greater chance you have that your transaction will be processed sooner. If you don't make any changes, your transaction will also get processes but it might take longer or your might pay more than is actually needed. 
          </Typography>

          <Typography variant="title">
            How accurate is this
          </Typography>
          <Typography>
            It is not possible to predict the exact fee or confirmation time so all of these are estimates but the chance of having a confirmed transaction for the set period (assuming we also set the suggested fee from here) is around 90%.
          </Typography>

          <div className={classes.donations}>
            <Typography variant="title">
              Donations
            </Typography>
            <Typography component="div">
              If you find this useful, please donate some <span>BTC</span>
              <BitcoinDonationAddress />
            </Typography>
          </div>
        </div>
      </footer>
    )
  }
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Footer)



// WEBPACK FOOTER //
// ./src/Footer.js